export const START_BULK_TASKS_DELETE_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_TASKS_DELETE_OPERATION'
export const LOAD_BULK_DELETE_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA'
export const LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS'
export const LOAD_BULK_DELETE_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA_FAILURE'

export const BULK_TASKS_DELETE = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE'
export const BULK_TASKS_DELETE_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE_SUCCESS'
export const BULK_TASKS_DELETE_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE_FAILURE'

export const START_BULK_ASSIGN_TASKS_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_ASSIGN_TASKS_OPERATION'
export const LOAD_BULK_ASSIGN_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA'
export const LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS'
export const LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE'
export const BULK_ASSIGN_DIALOG_SELECTION_SET = 'at/taskManagement/bulkOperations/BULK_ASSIGN_DIALOG_SELECTION_SET'

export const BULK_ASSIGN_TASKS = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS'
export const BULK_ASSIGN_TASKS_SUCCESS = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS_SUCCESS'
export const BULK_ASSIGN_TASKS_FAILURE = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS_FAILURE'

export const START_BULK_CHANGE_TASKS_STATUS_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_CHANGE_TASKS_STATUS_OPERATION'
export const LOAD_BULK_CHANGE_STATUS_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA'
export const LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS'
export const LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE'

export const BULK_CHANGE_TASKS_STATUS = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS'
export const BULK_CHANGE_TASKS_STATUS_SUCCESS = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS_SUCCESS'
export const BULK_CHANGE_TASKS_STATUS_FAILURE = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS_FAILURE'

export const START_BULK_MOVE_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_MOVE_OPERATION'
export const LOAD_BULK_MOVE_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA'
export const LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS'
export const LOAD_BULK_MOVE_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA_FAILURE'

export const BULK_TASKS_MOVE = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE'
export const BULK_TASKS_MOVE_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE_SUCCESS'
export const BULK_TASKS_MOVE_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE_FAILURE'

export const START_BULK_COPY_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_COPY_OPERATION'
export const BULK_TASKS_COPY = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY'
export const BULK_TASKS_COPY_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY_SUCCESS'
export const BULK_TASKS_COPY_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY_FAILURE'

export const BULK_OPERATION_PROGRESS_SET = 'at/taskManagement/bulkOperations/BULK_OPERATION_PROGRESS_SET'

export const CLEANUP_DIALOGS_DATA = 'at/taskManagement/bulkOperations/CLEANUP_DIALOGS_DATA'



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/actionTypes.js